// extracted by mini-css-extract-plugin
module.exports = {"modal-card-divided-body":"CreateAction_modal-card-divided-body__1hIKY"};